import axios from "axios";
import React, { useEffect } from "react";
import { useState } from "react"
import { useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { afterTaxDiscountCalculateTotal, beforeTaxDiscountCalculateTotal, withoutTaxAndDiscountCalculate, withoutTaxCalculate } from "../../utils/TaxCalculation";
import { DateTime } from "luxon";


const CreateSell2 = () => {

    const navigate = useNavigate();
    const params = useParams();
    const id = params.id;

    const { user } = useSelector(state => state.user);

    const [customerDetails, setCustomerDetails] = useState();


    useEffect(() => {
        (async () => {
            try {
                const response = await axios.get(`/customer/${id}`);
                if (response.data.success) {
                    setCustomerDetails(response.data.customer);
                }
            } catch (error) {
                console.log(error);
            }
        })()
    }, [])



    const [products, setproducts] = useState();
    const [categories, setCategories] = useState()
    const [disableProduct, setDisableProduct] = useState(true);
    const [disableQty, setDisableQty] = useState(true);
    const [disableTax, setDisableTax] = useState(false);
    const [disableCategory, setDisableCategory] = useState(true);


    useEffect(() => {
        (async () => {
            try {

                const response = await axios.get("/category/");
                if (response.data.success) {
                    setCategories(response.data.categories);
                }

            } catch (error) {
                toast.error(error.response.data.message);
            }
        })();

    }, []);


    const [selectedCategory, setselectedCategory] = useState();
    const [isCategorySelected, setIsCategorySelected] = useState(false);


    // value is id 
    const changeCategory = async (value, index) => {
        //value is category id
        rows[index]["category"] = value;

        //fetching products of selected category
        try {
            const response = await axios.get(`/product/get/${value}`);
            if (response.data.success) {
                let updatedRows = [...rows];
                updatedRows[index]["productList"] = response.data.products;
                setRows(updatedRows);
            }

        } catch (error) {
            toast.error(error.response.data.message);
        }

        // setselectedCategory(value);
        // setIsCategorySelected(true);
        // setDisableProduct(false);
    }

    useEffect(() => {

        if (isCategorySelected) {
            (async () => {
                try {

                    const response = await axios.get(`/product/get/${selectedCategory}`);

                    if (response.data.success) {
                        setproducts(response.data.products);
                        // if (response.data.products.length > 0) {
                        //     setDisableProduct(false);
                        // }
                    }

                } catch (error) {
                    toast.error(error.response.data.message);
                    setproducts([]);
                }

            })();
        }


    }, [selectedCategory]);





    const [paymentMethod, setPaymentMethod] = useState("");


    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!paymentMethod) {
            toast.error("Payment Method is required");
            return;
        }

        let data = {
            date,
            paymentMethod,
            customer: id,
            // category: selectedCategory,
            products: rows
        }

        console.log(data);


        try {
            const response = await axios.post("/sell/create2", data)
            if (response.data.success) {
                toast.success(response.data.message);
                navigate(`/invoice/${response.data.selling._id}`);
            }

        } catch (error) {
            toast.error(error.response.data.message);
        }
    }


    //Table 
    const [rows, setRows] = useState([{ category: '', product: '', quantity: "", price: "", sellingGst: "", total: "", availableQty: "", discount: "", productList: [], MRP: "" }]);

    const handleAddRow = () => {
        setRows([...rows, { category: '', product: '', quantity: "", price: "", sellingGst: "", total: "", availableQty: "", discount: "", productList: [], MPR: "" }]);
    };

    const handleRemoveRow = (index) => {

        // let temp = rows.slice(0, rows.length - 1);

        let temp = rows.slice(0, index);

        let temp2 = rows.slice(index + 1, rows.length);

        temp = temp.concat(temp2);

        if (temp.length < 1) {
            setRows([{ category: '', product: '', quantity: "", price: "", sellingGst: "", total: "", availableQty: "", discount: "", }])
        } else {
            setRows(temp);
        }
    }



    const [tax, setTax] = useState("");



    const handleInputChange = (index, field, value) => {
        console.log(field, value);
        let updatedRows = [...rows];
        if (field === "name") {

            updatedRows?.map((r) => {
                r?.productList?.map((p) => {
                    if (value === p.name) {
                        updatedRows[index]["product"] = p?._id;
                        if (!p?.sellingPrice) {
                            toast.warn("Selling price not found for selected product, Please set Selling price first!");
                        }
                        updatedRows[index]["price"] = p?.sellingPrice;
                        updatedRows[index]["sellingGst"] = p?.gst;
                        updatedRows[index]["availableQty"] = p?.stock;
                        updatedRows[index]["discount"] = p?.discount;

                        //injecting MRP
                        updatedRows[index]["MRP"] = p?.MRP;
                    }
                })
            })
        }

        updatedRows[index][field] = value;
        if (tax === "afterTax") {
            updatedRows[index]["total"] = afterTaxDiscountCalculateTotal(updatedRows[index].quantity, updatedRows[index].price, updatedRows[index].sellingGst, updatedRows[index].discount);
        } else if (tax === "beforeTax") {
            updatedRows[index]["total"] = beforeTaxDiscountCalculateTotal(updatedRows[index].quantity, updatedRows[index].price, updatedRows[index].sellingGst, updatedRows[index].discount);
        } else if (tax === "withoutTax") {
            updatedRows[index]["total"] = withoutTaxCalculate(updatedRows[index].quantity, updatedRows[index].price, updatedRows[index].discount);
        }
        else if (tax === "withoutTaxAndDiscount") {

            if (!updatedRows[index]["MRP"]) {
                toast.warn("MRP not found for selected product, Please set MRP first!");
                return
            }

            updatedRows[index]["total"] = withoutTaxAndDiscountCalculate(updatedRows[index].quantity, updatedRows[index]["price"]);

            //calculates discount based on MPR and selling price
            let diff = updatedRows[index]["MRP"] - updatedRows[index]["price"]
            let discountPercentage = (diff / (updatedRows[index]["MRP"])) * 100;
            updatedRows[index]["discount"] = Number(discountPercentage).toFixed(1);

        }

        setRows(updatedRows);
    };

    const [date, setDate] = useState(DateTime.now().toFormat("yyyy-MM-dd"));

    // handle reset category selection
    const handleReset = (e) => {
        setselectedCategory("");
        setTax("");
        setRows([{ category: '', product: '', quantity: "", price: "", sellingGst: "", total: "", availableQty: "" }])
        setIsCategorySelected(false);
        setDisableProduct(true);
        setDisableTax(false)
        setDisableCategory(true);
    }

    const getQuotation = async () => {
        if (!date || !paymentMethod) {
            toast.error("Date or Payment Method are required for quotation!");
            return;
        }

        let data = {
            date,
            paymentMethod,
            customer: id,
            // category: selectedCategory,
            products: rows
        }

        try {
            const response = await axios.post("/quotation/create", data);
            if (response.data.success) {
                let quotation = response.data.quotation;
                //  .../quotation is for bypassing the url, because of invalid url parameters, it doesnot have the id
                navigate("/invoice/quotation", { state: quotation?._id });
            }

        } catch (error) {
            toast.error(error.response.data.message);
        }


    }

    //calculating the grand total
    const [grandTotal, setGrandTotal] = useState();
    useEffect(() => {
        let grandTotal = 0;
        rows.forEach((r) => {
            grandTotal = grandTotal + r["total"];
        })
        setGrandTotal(grandTotal);
    }, [rows]);

    return (
        <>
            <div>
                <h1 className="text-center mt-6 bg-blue-300 rounded-lg mx-4 text-2xl font-semibold text-blue-700">Sell Products</h1>
                <form onSubmit={handleSubmit} >
                    <div className="grid grid-cols-2 gap-5 mx-10 mt-6">
                        <div>
                            <label htmlFor="date" className="font-bold">Date:</label>
                            <input id="date"
                                type="date"
                                name="date"
                                // value={date.toLocaleDateString()}
                                onChange={(e) => setDate(e.target.value)}
                                value={date}
                                className="input input-bordered input-info w-full" />
                        </div>

                        <div>
                            <label htmlFor="paidAmount" className="font-bold">Payment Method:</label>
                            {/* <input id="paymentMethod"
                                type="text"
                                list="suggestions"
                                name="paymentMethod"
                                value={paymentMethod}
                                placeholder="Select Payment Method"
                                onChange={(e) => setPaymentMethod(e.target.value)}
                                className="input input-bordered input-info w-full" required />

                            <datalist id="suggestions">
                                <option value="CASH">CASH</option>
                                <option value="CARD">CARD</option>
                                <option value="UPI">UPI</option>
                                <option value="NEFT">NEFT</option>
                            </datalist> */}

                            <select name="paymentMethod" onChange={(e) => setPaymentMethod(e.target.value)}
                                value={paymentMethod}
                                className="select select-info block w-full ">
                                <option selected>Select Payment Method</option>
                                <option value="CASH">CASH</option>
                                <option value="CARD">CARD</option>
                                <option value="UPI">UPI</option>
                                <option value="NEFT">NEFT</option>
                            </select>
                        </div>


                        <div>
                            <label htmlFor="customer" className="font-bold">Customer:</label>
                            <input id="customer"
                                type="text"
                                name="customer"
                                value={customerDetails?.name}
                                className="input input-bordered input-info w-full" readOnly />
                        </div>

                        {/* <div>
                            <label htmlFor="category" className="font-bold">Category:</label>
                            <select onChange={changeCategory} name="category" id="category" className="select select-info w-full" required
                            // disabled={isCategorySelected}
                            >
                                <option selected>Select Category</option>
                                {categories?.map((category) => {
                                    return (
                                        <>
                                            <option value={category?._id}>{category?.title}</option>
                                        </>
                                    )
                                })}
                            </select>
                        </div> */}
                    </div>

                    <div className="m-12 mb-0 ">
                        <h1 className="ml-5 text-2xl font-bold bg-blue-300 p-2 m-2">Total Amount Calculation with Discount</h1>

                        <label className="ml-5 text-xl mr-2 font-bold" htmlFor="withoutTaxAndDiscount">Without Tax and Discount</label>
                        <input type="radio" id="withoutTaxAndDiscount" name="tax" value="withoutTaxAndDiscount"
                            onChange={(e) => {
                                setTax(e.target.value)
                                setDisableTax(true)
                                setDisableCategory(false);
                            }}
                            disabled={disableTax} className="radio radio-primary" />

                        <label className="ml-5 text-xl mr-2 font-bold" htmlFor="withoutTax">Without Tax</label>
                        <input type="radio" id="withoutTax" name="tax" value="withoutTax"
                            onChange={(e) => {
                                setTax(e.target.value)
                                setDisableTax(true)
                                setDisableCategory(false);
                            }}
                            disabled={disableTax} className="radio radio-primary" />


                        <label className="ml-5 pb-8 text-xl mr-2 font-bold" htmlFor="afterTax">After Tax</label>
                        <input type="radio" id="afterTax" name="tax" value="afterTax"
                            onChange={(e) => {
                                setTax(e.target.value);
                                setDisableTax(true)
                                setDisableCategory(false);
                            }}
                            disabled={disableTax} className="radio radio-primary " />


                        <label className="ml-5 text-xl mr-2 font-bold" htmlFor="beforeTax">Before Tax</label>
                        <input type="radio" id="beforeTax" name="tax" value="beforeTax"
                            onChange={(e) => {
                                setTax(e.target.value)
                                setDisableTax(true)
                                setDisableCategory(false);
                            }}
                            disabled={disableTax} className="radio radio-primary" />
                    </div>


                    {/* Table................................................................. */}
                    <table className=" bg-white border mx-10 my-4">
                        <thead>
                            <tr>
                                {/* <th className="px-4 py-2 border">id</th> */}
                                <th className="px-4 py-2 border">Category</th>
                                <th className="px-4 py-2 border">Product</th>
                                <th className="px-4 py-2 border">Quantity</th>
                                <th className="px-4 py-2 border">Price</th>
                                <th className="px-4 py-2 border">Selling GST</th>
                                <th className="px-4 py-2 border">Discount</th>
                                <th className="px-4 py-2 border">Total</th>
                                <th className="px-4 py-2 border"></th>
                                <th className="px-4 py-2 border"></th>
                            </tr>
                        </thead>
                        <tbody >
                            {rows?.map((row, index) => (
                                <tr key={index}>
                                    <td>
                                        <select onChange={(e) => changeCategory(e.target.value, index)} name="category" id="category" className="select select-info w-[150px]" required
                                            disabled={disableCategory}>
                                            <option selected>Select Category</option>
                                            {categories?.map((category) => {
                                                return (
                                                    <>
                                                        <option value={category?._id}>{category?.title}</option>
                                                    </>
                                                )
                                            })}
                                        </select>
                                    </td>
                                    <td className="px-4  py-2 border">

                                        <select onChange={(e) => handleInputChange(index, "name", e.target.value)} className="select select-info w-[180px]">
                                            <option selected>Select Product</option>
                                            {
                                                row?.productList?.map((p) => {
                                                    return (
                                                        <>
                                                            <option value={p.name}>{p?.name}</option>
                                                        </>
                                                    )
                                                })
                                            }
                                        </select>

                                        {/* <input
                                            type="text"
                                            list="suggestion"
                                            className="w-full px-2 py-1 border rounded"
                                            placeholder="Enter product"
                                            value={row?.name || ''}
                                            // disabled={disableProduct}
                                            onChange={(e) => {
                                                handleInputChange(index, 'name', e.target.value);
                                                // changeProduct(row?.id)
                                            }}
                                        /> */}



                                    </td>
                                    {/* <td  className="px-4 py-2 border">
                                    <input id="customer"
                                type="text"
                                name="customer"
                                value={productName}
                                className="input input-bordered input-info w-full" readOnly />
                                    </td> */}

                                    <td className="px-4 py-2 border">
                                        <input
                                            type="number"
                                            className="w-[200px] px-2 py-1 border rounded placeholder:text-green-600"
                                            placeholder={`${row.availableQty} InStock`}
                                            value={row?.quantity}
                                            // disabled={disableProduct}
                                            min="1"
                                            max={row?.availableQty.toString()}
                                            onChange={(e) => handleInputChange(index, 'quantity', e.target.value)}
                                        />
                                    </td>
                                    <td className="px-4 py-2 border">
                                        <input
                                            type="number"
                                            className="w-full px-2 py-1 border rounded placeholder:text-green-600"
                                            placeholder="Enter Price"
                                            value={row?.price}
                                            disabled="true"
                                        // onChange={(e) => handleInputChange(index, 'price', e.target.value)}
                                        />
                                    </td>
                                    <td className="px-4 py-2 border">
                                        <input
                                            type="number"
                                            className="w-full px-2 py-1 border rounded placeholder:text-green-600"
                                            placeholder="in %"
                                            value={row?.sellingGst}
                                            disabled="true"
                                        // onChange={(e) => handleInputChange(index, 'sellingGst', e.target.value)}
                                        />
                                    </td>
                                    <td className="px-4 py-2 border">
                                        <input
                                            type="number"
                                            className="w-full px-2 py-1 border rounded placeholder:text-green-600"
                                            placeholder="in %"
                                            value={row?.discount}
                                            disabled="true"
                                        // onChange={(e) => handleInputChange(index, 'sellingGst', e.target.value)}
                                        />
                                    </td>
                                    <td className="px-4 py-2 border">
                                        <input
                                            type="text"
                                            className="w-full px-2 py-1 border rounded placeholder:text-green-600"
                                            placeholder="Total Amount"
                                            value={row?.total.toLocaleString('en-IN')}
                                            disabled="true"
                                            onClick={(e) => handleInputChange(index, 'total', e.target.value)}
                                        />
                                    </td>
                                    <td className="px-4 py-2 border text-center">
                                        {index === rows.length - 1 && (
                                            <button
                                                type="button"
                                                className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded-full"
                                                onClick={handleAddRow}>
                                                +
                                            </button>
                                        )}
                                    </td>
                                    <td className="px-4 py-2 border text-center">
                                        {
                                            index === rows.length - 1 && (

                                                <button
                                                    type="button"
                                                    className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded-full"
                                                    onClick={() => {
                                                        handleRemoveRow(index)
                                                    }}>
                                                    -
                                                </button>
                                            )}

                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>



                    <div className="mx-10 space-x-2">
                        <button type="submit" className="btn btn-success text-white font-bold">Submit</button>
                        <button onClick={handleReset} type="reset" className="btn btn-error text-white font-bold">Reset</button>
                        <button onClick={getQuotation} type="button" className="btn btn-success text-white font-bold">Get Quotation</button>
                    </div>
                    <div className="text-2xl text-center">
                        <h1 className="bg-blue-400 mx-5 rounded-md mt-4 font-bold">Grand Total: ₹{Number(Number(grandTotal)?.toFixed(2))?.toLocaleString("en-IN")}/-</h1>
                    </div>

                </form>






            </div>
        </>
    )
}

export default CreateSell2;